// Ответ ответственного (030: contracts/api.md, «Протокол»; data-model.md, `minutes.item_answers`;
// research Р6; ASG-FLOW-10, ASG-FLOW-01, ASG-DESK-05). Ответ — факт о команде таблицы: та же
// ревизия, что у правки пункта; «Отменить» команду снимает и ответ. Пометка у пункта на планёрке —
// последний неотменённый ответ после последнего снимка недели (FR-040).
import { z } from '../kernel/zod.ts';
import { TimestampSchema } from '../kernel/common.ts';

/** Причина переноса срока и пояснение «Ошибки в пункте» (data-model.md). */
export const ANSWER_REASON_MAX = 500;
/** «Пояснение…» и пояснение «Ошибки в пункте…» — как пояснение к состоянию (WORK_NOTE_MAX). */
export const ANSWER_NOTE_MAX = 2000;

/** Вид ответа: «Выполнено», «Новый срок…», «Пояснение…», «Ошибка в пункте…». */
export const itemAnswerKinds = ['done', 'due', 'note', 'report'] as const;
export type ItemAnswerKind = (typeof itemAnswerKinds)[number];
export const ItemAnswerKindSchema = z.enum(itemAnswerKinds);

/**
 * 032 (FR-005, FR-009; data-model.md, `minutes.item_answers.channel`): откуда ответ — «Мои задачи»,
 * страница ответа по личной ссылке, ответ из письма, который внёс контролёр.
 */
export const itemAnswerChannels = ['my', 'letter', 'letter_controller'] as const;
export type ItemAnswerChannel = (typeof itemAnswerChannels)[number];
export const ItemAnswerChannelSchema = z.enum(itemAnswerChannels);

export const itemAnswerChannelLabels = {
  my: '',
  letter: 'ответ из письма',
  letter_controller: 'ответ из письма, внёс контролёр',
} as const satisfies Record<ItemAnswerChannel, string>;

/** Причина «Ошибки в пункте…» (FR-035): «Не мой пункт», «Неверный текст или срок», «Другое». */
export const reportReasons = ['not_mine', 'wrong', 'other'] as const;
export type ReportReason = (typeof reportReasons)[number];
export const ReportReasonSchema = z.enum(reportReasons);

export const reportReasonLabels = {
  not_mine: 'Не мой пункт',
  wrong: 'Неверный текст или срок',
  other: 'Другое',
} as const satisfies Record<ReportReason, string>;

/**
 * Пометка ответа у строки таблицы и в листе контроля (FR-040): «ответил: Выполнено 03.11»,
 * «новый срок 13.11: <причина>», «ошибка в пункте». by — ФИО ответившего.
 */
export const ItemAnswerMarkSchema = z.object({
  kind: ItemAnswerKindSchema,
  at: TimestampSchema,
  by: z.string(),
  dueRaw: z.string().optional(),
  reason: z.string().optional(),
});
export type ItemAnswerMark = z.infer<typeof ItemAnswerMarkSchema>;
